var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-autocomplete',{attrs:{"size":"small","fetch-suggestions":_vm.querySearchAsync,"disabled":_vm.disable,"placeholder":"请输入权限名称"},on:{"select":_vm.handleChange,"blur":_vm.handleBlur},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"label",attrs:{"title":item.value}},[_vm._v(_vm._s(item.value))])]}}]),model:{value:(_vm.permissionIds),callback:function ($$v) {_vm.permissionIds=$$v},expression:"permissionIds"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c62d09e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/PermissionsSelect.vue
// module id = 2518
// module chunks = 0